/* Kiid "Upsell offers" cart block: keeps the offers in step with the cart.
   After every cart change the theme fires "theme:cart:change". The block then re-fetches its own
   section from the server (which re-reads the cart) and swaps in the new list. */
(() => {
  if (window.kiidCartUpsellLoaded) return;
  window.kiidCartUpsellLoaded = true;

  const SELECTOR = '[data-kiid-upsell]';
  let timer = null;
  let runId = 0;

  const refresh = async () => {
    const holders = document.querySelectorAll(SELECTOR);
    if (!holders.length) return;
    const myRun = ++runId;
    const ids = [...new Set([...holders].map((h) => h.dataset.sectionId).filter(Boolean))];

    await Promise.all(
      ids.map(async (id) => {
        try {
          const url = `${window.location.pathname}?section_id=${encodeURIComponent(id)}&t=${Date.now()}`;
          const response = await fetch(url, {credentials: 'same-origin'});
          if (!response.ok) return;
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const fresh = [...doc.querySelectorAll(SELECTOR)].find((el) => el.dataset.sectionId === id);
          if (!fresh || myRun !== runId) return;

          document.querySelectorAll(SELECTOR).forEach((live) => {
            if (live.dataset.sectionId !== id) return;
            live.innerHTML = fresh.innerHTML;
            live.hidden = fresh.hidden;
          });
        } catch (error) {
          /* keep the current list if the refresh fails */
        }
      })
    );
  };

  document.addEventListener('theme:cart:change', () => {
    clearTimeout(timer);
    // Short wait so the "Added" confirmation on the button can show before the row is replaced.
    timer = setTimeout(refresh, 700);
  });
})();
